import React from 'react';

const Store = ({ points }) => (
  <div className="max-w-md mx-auto text-center">
    <h2 className="text-2xl font-bold mb-4">Store</h2>
    <p>Current Points: {points}</p>
    <p className="text-gray-600 mt-4">
      Store coming soon! For now, earn points by solving puzzles and your daily free points.
    </p>
  </div>
);

export default Store;
